module.exports = __webpack_public_path__ + "img/coroprate_sustainability.c3af5062.jpg";